import { trackEvent } from '@saaga/shared/utils/analytics.util'
import { logger } from '@saaga/shared/utils/logger.util'
import { toast } from 'sonner'

type MutationTrigger = (slug: string) => { unwrap: () => Promise<void> }

export const deleteAgency = async (
  slug: string,
  name: string,
  deleteFn: MutationTrigger
): Promise<void> => {
  try {
    await deleteFn(slug).unwrap()
    trackEvent('agency_deleted', { agencySlug: slug, agencyName: name })
    toast.success('Agency deleted')
  } catch (error) {
    logger.error('Failed to delete agency', error)
    toast.error('Failed to delete agency')
  }
}
